import axiosInstance from "../Middleware/interceptor";
import { toast } from "react-toastify";


export const postApi = async (url, data) => {
  try {
    const response = await axiosInstance.post(`${url}`, data);
    
    if (response?.status === 200) {
      toast.success(response?.data?.message);  // Success toast
    } else {
      toast.error(response?.data?.message);  // Error toast if statusCode is not 200
    }

    return response?.data;
  } catch (error) {
    // Catching any error (e.g., 500 internal server error) and showing it as a toast
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      toast.error(`Error: ${error.response.data.message || 'An unexpected error occurred'}`);
    } else if (error.request) {
      // The request was made but no response was received
      toast.error('No response from server. Please try again later.');
    } else {
      // Something else happened while setting up the request
      toast.error(`Error: ${error.message}`);
    }

    throw error; // Re-throw the error to propagate it further if necessary
  }
};

export const getApi = async (url) => {
  try {
    const response = await axiosInstance.get(`${url}`);
    
    if(response?.status === 200){
      // toast.success(response?.data?.message)
      } else{
        toast.error(response?.data?.message)
      }
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const putApi = async (url, data) => {
  try {
    const response = await axiosInstance.put(`${url}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteApi = async (url, data) => {
  try {
    const response = await axiosInstance.delete(`${url}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const patchApi = async (url, data) => {
  try {
    const response = await axiosInstance.patch(`${url}`, data);
    if (response?.data?.statusCode === 200) {
      toast.success(response?.data?.message); // Success toast
    } else {
      toast.error(response?.data?.message); // Error toast if statusCode is not 200
    }
    return response?.data;
  } catch (error) {
    if (error.response) {
      toast.error(`Error: ${error.response.data.message || 'An unexpected error occurred'}`);
    } else if (error.request) {
      toast.error('No response from server. Please try again later.');
    } else {
      toast.error(`Error: ${error.message}`);
    }
    throw error; // Re-throw the error to propagate it further if necessary
  }
};
